export default __webpack_public_path__ + "static/media/purchase.d72fa360.svg";